export enum LifeEventEnum {
    None = 1,
    Marriage = 2,
    Divorce = 3,
    DeathOfSpouse = 4,
    BirthOfChild = 5,
    DeathOfChild = 6,
    ChangeInEligibility = 7,
    Other = 8,
    PartTimeToFullTime = 9,
    Adoption = 10,
    LossOfCoverage = 11,
    GainOfCoverage = 12,
    NetworkChange = 13,
}
